import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import RealPeopleFeed from 'src/app/organisms/Homepage/RealPeopleFeed/RealPeopleFeed';

const RealPeople = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
    background='bg-tertiary'
  >
    <RealPeopleFeed />
  </SectionLayout>
);

export default RealPeople;
